import { useState, useCallback } from "react";

import { useValues } from "2g-form";

import { useProvozniInformaceSeznam } from "b2b/api/hooks";
import { useProvozniInformaceSearch } from "b2b/components/provozni-informace-search";
import { PATHS } from "b2b/constants";
import { useRedirect } from "b2b/hooks";

import getInitialValues from "./utils/getInitialValues";

const MODULE_KEY = "provozniInformaceSearch";

export default function useProvozniInformace() {
  const redirect = useRedirect();
  const [initialValues] = useState(getInitialValues());
  const values = useValues(MODULE_KEY);
  const loader = useProvozniInformaceSeznam(values || initialValues);

  const onSubmit = useCallback(() => {
    loader.load();
  }, [loader.load]);

  const filter = useProvozniInformaceSearch({
    onSubmit,
    initialValues,
    moduleKey: MODULE_KEY
  });

  const redirectToVytvoreni = useCallback(() => {
    redirect(PATHS.PROVOZNI_INFORMACE.VYTVORENI);
  }, []);

  return {
    filter,
    loading: loader.loading,
    items: loader.data,
    reload: loader.reload,
    redirectToVytvoreni
  };
}
